<template lang="pug">
  .selectpicker
    label.selectpicker__label
      template(v-if="label") {{label}}
      v-icon.selectpicker__chevron(name="chevron-down")
      span.selectpicker__placeholder(v-if="!value") {{ placeholder }}
      select.selectpicker__select(v-model="currentValue" @change="onChange")
        option(
          v-for="(option, i) in options"
          :key="i"
          :value="option.value"
        ) {{ option.name }}
      button.clear-button.selectpicker__clear(@click="$emit('clear')" v-if="value" )
        v-icon.select-box__clear-icon(name="x")
    button.button.button--primary.selectpicker__button(
      v-if="showButton"
      @click="$emit('input', value)"
    ) {{buttonText}}
</template>

<script>

export default {
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    showButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonText: {
      type: String,
      required: false,
      default: 'Применить'
    }
  },
  watch: {
    value: function (newVal) {
      this.currentValue = newVal;
    }
  },
  data() {
    return {
      currentValue: null,
    }
  },
  mounted() {
    this.currentValue = this.value;
  },
  methods: {
    onChange() {
      this.$emit('change', this.currentValue);
    }
  }
}
</script>
